import BaseCrudService from './baseCrud.service'

class AgencyService extends BaseCrudService {
  constructor () {
    super('agency', {
      id: false,
      parent_id: null,
      agency_id: 0,
      name: '',
      address: '',
      zip: '',
      region: '',
      country: '',
      city: '',
      director_name: '',
      phone: '',
      email: '',
      website_url: '',
      notes: '',
      groups: [],
      status: 1,
      created_by: 1
    })
  }

  getListAll (params, ...callbacks) {
    params = params || { extended: true }
    params = Object.assign(params, { extended: true })
    return super.getList(params, ...callbacks)
  }

  getList (params, ...callbacks) {
    params = params || { filter: { 'parent_id': null } }
    if (params.hasOwnProperty('filter') && typeof params.filter === 'object') {
      params.filter['parent_id'] = null
    } else {
      params.filter = { parent_id: null }
    }
    return super.getList(params, ...callbacks)
  }

  addAgent (id, agentId, ...callbacks) {
    this.constructor.get(this.endpoints().addAgent.replace('{:id}', id).replace('{:agentId}', agentId), {}, ...callbacks)
  }

  deleteAgent (id, agentId, ...callbacks) {
    this.constructor.get(this.endpoints().deleteAgent.replace('{:id}', id).replace('{:agentId}', agentId), {}, ...callbacks)
  }

  setRole (id, agentId, role, ...callbacks) {
    this.constructor.get(this.endpoints().setRole.replace('{:id}', id).replace('{:agentId}', agentId), { params: { 'role': role } }, ...callbacks)
  }

  setPassword (id, agentId, password, ...callbacks) {
    this.constructor.post(this.endpoints().setPassword.replace('{:id}', id).replace('{:agentId}', agentId), { 'password': password }, ...callbacks)
  }

  getAgents (id, params, ...callbacks) {
    params = params || { sort: '-id', page: 1 }
    this.constructor.get(
      this.endpoints().participants.replace('{:id}', id),
      {
        params: Object.assign({
          sort: params.sort,
          page: params.page,
          q: params.q,
          role: params.role || ['agencyAgent', 'agencyUnlicensedAgent']
        },
        {
          filters: JSON.stringify(params.filter)
        })
      }, ...callbacks)
  }
}

export default AgencyService
